import React from 'react';
import { MdScreenShare } from 'react-icons/md';
import { Box, IconButton, Tooltip } from '@chakra-ui/react';

import { useScreenShareParticipant, useVideoContext } from 'hooks/session';

export const SCREEN_SHARE_TEXT = 'Share Screen';
export const STOP_SCREEN_SHARE_TEXT = 'Stop Sharing Screen';
export const SHARE_IN_PROGRESS_TEXT =
  'Cannot share screen when another user is sharing';
export const SHARE_NOT_SUPPORTED_TEXT =
  'Screen sharing is not supported with this browser';

interface Props {
  disabled?: boolean;
}

const ToggleScreenShareButton: React.FC<Props> = ({ disabled }: Props) => {
  const screenShareParticipant = useScreenShareParticipant();
  const { toggleScreenShare } = useVideoContext();
  const disableScreenShareButton = Boolean(screenShareParticipant);
  const isScreenShareSupported =
    // @ts-ignore
    navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;
  const isDisabled =
    disabled || disableScreenShareButton || !isScreenShareSupported;

  let tooltipMessage = '';

  if (disableScreenShareButton) {
    tooltipMessage = SHARE_IN_PROGRESS_TEXT;
  }

  if (!isScreenShareSupported) {
    tooltipMessage = SHARE_NOT_SUPPORTED_TEXT;
  }

  return (
    <Tooltip
      label={tooltipMessage}
      placement="top"
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
      shouldWrapChildren
    >
      <IconButton
        aria-label={SCREEN_SHARE_TEXT}
        onClick={toggleScreenShare}
        disabled={isDisabled}
        icon={<MdScreenShare />}
        data-cy-share-screen
        minH="100%"
      />
    </Tooltip>
  );
};

export default ToggleScreenShareButton;
